var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-sm text-gray-800 space-y-1"},[_c('div',{staticClass:"flex gap-x-2"},[_c('span',{staticClass:"font-medium text-gray-600"},[_vm._v(_vm._s(_vm.$t('active_lines')))]),_vm._v(" "),_c('span',{staticClass:"text-gray-900 font-semibold"},[_vm._v(_vm._s(_vm.activeLinesLabel()))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }